import { render, staticRenderFns } from "./TabelaDeAprovadores.vue?vue&type=template&id=4bd95068&scoped=true"
import script from "./TabelaDeAprovadores.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeAprovadores.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeAprovadores.vue?vue&type=style&index=0&id=4bd95068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd95068",
  null
  
)

export default component.exports